import { Field } from 'formik';

const DateTimeBox = ({
  label,
  name,
  isRequired,
  placeholder,
  value,
  defaultValue,
  handleChange,
  maxDate,
  minDate,
  errormsg,
  fieldFlag,
  disabled,
}) => {
  return (
    <>
      <label htmlFor={name}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      <Field
        className="formik-input"
        type="datetime-local"
        name={name}
        fullwidth
        disabled={disabled}
        autoComplete="given-name"
        id={'textarea-' + name}
        variant="outlined"
        // value={value ? value : defaultValue}
        value={value ?? defaultValue ?? ''}
        onChange={(e) => handleChange(e, fieldFlag)}
        {...(maxDate && { max: maxDate })}
        {...(minDate && { min: minDate })}
        {...(placeholder ? { placeholder: placeholder } : {})}
      />
      {errormsg && <div className="error-message">{errormsg}</div>}
    </>
  );
};

export default DateTimeBox;
